<template>
  <div class="inf">
    <el-card class="status_card" v-if="ruleForm.status != 1  && ruleForm.status != 0">
      <div>
        审核状态：
        <el-tag v-if="ruleForm.status == 1" type="success" class="prescription_type" effect="dark" disable-transitions>通过</el-tag>
        <el-tag v-if="ruleForm.status == 0" type="warning" class="prescription_type" effect="dark" disable-transitions>待审核</el-tag>
        <el-tag v-if="ruleForm.status == -1" type="danger" class="prescription_type" effect="dark" disable-transitions>拒绝</el-tag>
      </div>
      <div v-if="ruleForm.status == -1" class="p_bd">
        原因：{{ ruleForm.advice }}
      </div>
    </el-card>
    <!--<div class="alert_text">
      <el-alert :closable="false" title="审核通过后：我的资质与实名认证信息不能更改。医生可正常接诊患者。审核被拒：请根据审核失败信息，补充并提交信息" type="warning" show-icon>
      </el-alert>
    </div>-->
    <div class="front-img" v-if="ruleForm.status == 0  && ruleForm.profileStep === 4">
      <img src="../../../../../assets/images/toAudit.png" alt />
      <span class="front_word" >您的信息已提交，请耐心等待审核结果</span>
    </div>
    <div class="front-img" v-if="ruleForm.status == 1">
      <img src="../../../../../assets/images/auditPass.png" alt />
      <span class="front_word" >你的审核已通过，可正常审核处方</span>
    </div>
    <div class="front-img" v-if="ruleForm.status == -1">
      <img src="../../../../../assets/images/auditDown.png" alt />
      <span class="front_word" >您提交的认证资质不齐全，请仔细查阅资料后，重新上传</span>
      <div class="hint_info">
        <el-button class="again_btn" @click="againChange()">再次修改</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getDoctorInfo,
} from "@/api/index.js";
export default {

  data() {
    return {
      ruleForm: {},
    }
  },
  mounted() {
    this.getUserInfo();
    this.$store.commit('updateActive', 4)
    
  },
  computed:{
  },
  methods: {
  
    /**
     * @desc 个人信息回显
     */
    async getUserInfo() {
      try {
        const params = {};
        let res = await getDoctorInfo(params);
        if (res.success) {
          this.ruleForm = res.result;
          console.log(res.result);
        }
      } catch (error) {
        console.log(error);
      }
    },
    againChange(){
      this.$store.commit('againUpdate', true);
      this.$router.push('/index/user/auditInformation/information');
      // this.ruleForm.status = 0;
      console.log(this.ruleForm.status);
    },
  }

};
</script>

<style lang="scss" scoped>
.inf {
  height: 100%;
  padding: 250px;
  padding-top: 39px;
  margin: 0 auto;
  .hint_info{
    text-align: center;
    padding: 10px;
    border-radius: 15px;
  }
}

.alert_text{
  width: 490px;
  margin: 0 auto;
}
.front-img{
  width: 60%;
  margin: 0 auto;
}
.front-img img {
  width: 100px;
  height: 100%;
  display: block;
  margin: 0 auto;
}
.front_word{
  font-size: 20px;
  color: #666;
  display: block;
  margin: 0 auto;
  width: 340px;
  margin-top:30px;
}
.status_card{
  position: fixed;
  top: 130px;
  right: 40px;
  padding-top: 20px;
  width: 20%;
}
</style>
